import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import authService from '../services/authService';
import { loginSuccess, loginError } from '../redux/AuthSlice';
import { userUpdate } from '../redux/UserSlice';

export const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    // Khởi tạo auth state
    useEffect(() => {
        const initAuth = () => {
            console.log('useAuth.initAuth - starting');
            const authenticated = authService.isAuthenticated();
            const userData = authService.getUserData();
            
            console.log('useAuth.initAuth - authenticated:', authenticated);
            console.log('useAuth.initAuth - userData:', userData);
            
            setIsAuthenticated(authenticated);
            setUser(userData);
            setLoading(false);
            
            if (authenticated && userData) {
                dispatch(loginSuccess({
                    accessToken: authService.getAccessToken(),
                    userData: userData,
                    expiredAt: authService.getExpiredAt()
                }));
                dispatch(userUpdate({ userData }));
            }
        };

        initAuth();
    }, [dispatch]);

    // Đăng nhập
    const signIn = useCallback((authData) => {
        console.log('useAuth.signIn called with:', authData);
        try {
            authService.setAuthData(authData);
            
            setIsAuthenticated(true);
            setUser(authData.userData);
            
            dispatch(loginSuccess(authData));
            dispatch(userUpdate({ userData: authData.userData }));
            
            console.log('useAuth.signIn - success');
            return { success: true };
        } catch (error) {
            console.error('useAuth.signIn - error:', error);
            dispatch(loginError({ message: error.message }));
            return { success: false, error: error.message };
        }
    }, [dispatch]);

    // Đăng xuất
    const signOut = useCallback(() => {
        authService.logout();
        setIsAuthenticated(false);
        setUser(null);
    }, []);

    // Refresh token thủ công
    const refreshToken = useCallback(async () => {
        try {
            const newToken = await authService.refreshToken();
            return { success: true, token: newToken };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }, []);

    return {
        isAuthenticated,
        user,
        loading,
        signIn,
        signOut,
        refreshToken
    };
};

export default useAuth;
